import { getDreamsTokens } from '@/services/api';
import { useAuth } from '@/services/auth';
import { useQuery } from 'react-query';

export const GET_DREAMS_TOKENS_KEY = 'get-dreams-tokens';

export const useDreamsTokens = () => {
    const { isAnonymous } = useAuth();

    return useQuery(GET_DREAMS_TOKENS_KEY, getDreamsTokens, {
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        initialData: {
            used: 0,
            limit: isAnonymous ? 15 : 0,
        },
        retry(failureCount, error: any) {
            if (error?.response?.data?.kind === 'InsufficientCreditsError') {
                return false;
            }

            return failureCount < 3 && error.status === 401;
        },
        enabled: !isAnonymous,
    });
};
